import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { map } from "lodash"
import LeadBySource from "./lead"
import Apaexlinecolumn from "./apaexlinecolumn"
import Revnue from "../AllCharts/apex/revnueLine"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import WelcomeComp from "./WelcomeComp"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
//import CalenderShort from "../Activities/calander-short"
import appointment from "../../assets/images/rsicons/appointment.png"
import activiti from "../../assets/images/rsicons/activities.png"
import call from "../../assets/images/rsicons/call.png"
import notes from "../../assets/images/rsicons/notes.png"
import todo from "../../assets/images/rsicons/to-do.png"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Moment from "react-moment";
import moment from 'moment';
import { postActivityFilter } from "store/actions"
//import LatestLeads from "../Lead/LatestLeads"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Select,
  Nav,
  NavItem,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormGroup,
  Label,
   Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody
} from "reactstrap"
import { API_URL } from "helpers/app_url";
import axios from "axios";
import RsLink from "components/buttons/rsLink";
import RSBarChart from "components/charts/RSBarChart";
import classnames from "classnames"
import SaveButton from "components/buttons/save";
import SafeField from "helpers/SafeField";
class DashboardNew extends Component {
  constructor(props) {
    super(props)
    this.state = {
       projecttopfive: [],
      totalContact:0,
      activity:'',
      totalClient:0,
      totalLead:0,
       projectCounts: [],
       projectMonthNames: [],
        activeTab: '1',
        open: '',
   
    }
    this.accordionId = `dealsAccordion-${Math.random().toString(36).substr(2, 9)}`;
    this.toggleEdit = this.toggleEdit.bind(this);
    this.toggleSellerShowing = this.toggleSellerShowing.bind(this);
    this.toggleOpenhouseShowing = this.toggleOpenhouseShowing.bind(this);
    this.toggleBuyerShowing = this.toggleBuyerShowing.bind(this)
    this.toggleEventShowing = this.toggleEventShowing.bind(this)
  }

  toggleEdit() {
  this.setState({ activity: "", isEdit: false, iseditOpen: !this.state.iseditOpen });
  this.editToggle();
}
editToggle() {
  this.setState(prevState => ({
      iseditOpen: !prevState.iseditOpen
  }));
}
toggleEdit = arg => {
  const activity = arg;
  this.setState({
    activity: {
            id: activity.id,
            activityId: activity.activityId,
            agentId: activity.agentId,
            title: activity.title,
            contactName: activity.contactName,
            contactPhone: activity.contactPhone,
            contactEmail: activity.contactEmail,
            activityStartDate: activity.activityStartDate,
            startTime: activity.startTime,
            endTime: activity.endTime,
            activityType: activity.activityType,
            activityStatus: activity.activityStatus,
            activityRefId: activity.activityRefId,
            activityDescription: activity.activityDescription,
            activityLocationType: activity.activityLocationType,
            activityLocation: activity.activityLocation,
            activityLatitude: activity.activityLatitude,
            activityLongitude: activity.activityLongitude,
            isActive: activity.isActive
      },
      isEdit: true,
  });
  this.editToggle();
};
 sellerShowingToggle() {
    this.setState(prevState => ({
        isSellerShowing: !prevState.isSellerShowing
    }));
  }
 
  toggleSellerShowing = arg => {
    const activity = arg;
    const {  onGetSellerShowingDetail } = this.props;
    onGetSellerShowingDetail(activity.id);
    this.sellerShowingToggle();
  };

  buyerShowingToggle() {
    this.setState(prevState => ({
        isBuyerShowing: !prevState.isBuyerShowing
    }));
  }
  toggleBuyerShowing = arg => {
    const activity = arg;
    const {  onGetBuyerShowingDetail } = this.props;
    onGetBuyerShowingDetail(activity.id);
    this.buyerShowingToggle();
  };

  eventShowingToggle() {
    this.setState(prevState => ({
        isEventShowing: !prevState.isEventShowing
    }));
  }
  toggleEventShowing = arg => {
    const activity = arg;
    const {  onGetProjectInviteDetail } = this.props;
    onGetProjectInviteDetail(activity.id);
    this.eventShowingToggle();
  };

  openhouseShowingToggle() {
    this.setState(prevState => ({
        isOpenhouseShowing: !prevState.isOpenhouseShowing
    }));
  }
  toggleOpenhouseShowing = arg => {
    const activity = arg;
    const {  onGetOpenhouseShowingDetail } = this.props;
    onGetOpenhouseShowingDetail(activity.id);
    this.openhouseShowingToggle();
  };

    toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
   getDateRange = (period, dateRange = [new Date(), new Date()]) => {
      const today = moment().startOf('day');
      switch (period) {
        case 'Today':
          return {
            from: today.clone().set({ hour: 0, minute: 0, second: 1 }),
            to: today.clone().set({ hour: 23, minute: 59, second: 59 })
          };
          case 'Overdue':
            //this.fetchOverDueData();
        case 'Tomorrow':
          const tomorrow = today.clone().add(1, 'days').startOf('day');
          //
          return {
            from: tomorrow,
            to: tomorrow
          };
        case 'This Week':
          const startOfThisWeek  = today.clone().startOf('week').set({ hour: 0, minute: 0, second: 1 });
          const endOfThisWeek  = today.clone().endOf('week').set({ hour: 23, minute: 59, second: 59 });
          return { from: startOfThisWeek, to: endOfThisWeek  };
          case 'Next Week':
            const startOfNextWeek = today.clone().add(1, 'week').startOf('week').set({ hour: 0, minute: 0, second: 1 });
            const endOfNextWeek = today.clone().add(1, 'week').endOf('week').set({ hour: 23, minute: 59, second: 59 });
            return { from: startOfNextWeek, to: endOfNextWeek };
        case 'Select Period':
        
        if (dateRange.length !== 2 || !moment(dateRange[0]).isValid() || !moment(dateRange[1]).isValid()) {
          throw new Error("dateRange must be an array with two valid dates [startDate, endDate]");
        }
          const [startDate, endDate] = dateRange;
          //
  
          return {
            from: moment(startDate).set({ hour: 0, minute: 0, second: 1 }),
            to: moment(endDate).set({ hour: 23, minute: 59, second: 59 })
          };
        default:
          
          return {
            from: today.clone().set({ hour: 0, minute: 0, second: 1 }),
            to: today.clone().set({ hour: 23, minute: 59, second: 59 })
          };
      }
  };
   
    fetchData = () => {
      const { activeTab, activePeriod, dateRange   } = this.state;
      const activityTypeIdMap = {
        'All': 0,
        'Calls': 3,
        'Meetings': 1,
        'To-do': 2,
        'Emails': 4,
        'Client Events': 2,
        'Deadlines': 5,
        'Seller Showings': 6,
        'Buyer showing': 7,
        'Open house': 8,
        'Event Invites': 9,
        'Message' : 10
      };
  
      const isAllSelected = activeTab === 'All';
      const activityTypeId = 0;
      const { from, to } = this.getDateRange(activePeriod, dateRange );
      const { from: convertedFrom, to: convertedTo } = this.convertDateRange(from, to);
      //
      const requestData = {
        activityTypeId:Array.isArray(activityTypeId) ? activityTypeId : [activityTypeId],
        activityFromDate: moment(convertedFrom).format('YYYY-MM-DD'),
        activityToDate: moment(convertedTo).format('YYYY-MM-DD'),
        agentId: parseInt(localStorage.getItem("userId"))
      };
      this.props.postActivityFilter(requestData)
     
    };
  convertDateRange = (activityFromDate, activityToDate) => {
      const from = moment(activityFromDate).startOf('day');
      const to = moment(activityToDate).endOf('day');
      //
      return { from, to };
  };

  fetchDeals(){
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("userId"),
    };
    axios
    .get(`${API_URL}ClientEngagement/allbyagent`, { headers, params })
    .then((response) => {
      this.setState({ deals: response.data, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}

  componentDidMount() {
    this.fetchData();
    this.fetchDeals();
    this.fetchClientNotification();
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    axios.get(`${API_URL}ProjectExt/getProjectCountByAgent`, {
      params: {
        agentId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {

        this.setState({ totalContact: res.data.countContact, totalClient: res.data.countClient, totalLead: res.data.countLead, totalLeadtoClient: res.data.countLeadtoClient });
      });
 axios.get(`${API_URL}ProjectExt/getProjectLunchMonthByAgent`, {
                    params: {
                      agentId: localStorage.getItem("userId"),
                    }, headers: { Authorization: str }
                  })
                    .then(res => {
                      this.setState({ projectMonthNames: res.data.months, projectCounts: res.data.counts });
                    });

        axios.get(`${API_URL}ProjectExt/getProjectTopFiveProjectsByAgent`, {
                        params: {
                          agentId: localStorage.getItem("userId"),
                        }, headers: { Authorization: str }
                      })
                        .then(res => {
                          this.setState({ projecttopfive: res.data });
                        });
                  
    }
getBuyerType = (type) => {
  if (type == 1)
    return 'Rent';
  else if (type == 2)
    return 'Purchase';

}

getSellerType = (type) => {
  if (type == 1)
    return 'Sell';
  else if (type == 2)
    return 'Lease';

}
getCommType = (type) => {
  if (type == 3)
    return 'Fixed';
  else if (type == 4)
    return '%';

}
 fetchClientNotification() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      ForId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}Notification/allAgent`, { headers, params })
      .then((response) => {
        this.setState({ clientnotificationsData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  convertISOTo12Hour = (isoString) => {
  const date = new Date(isoString);
  let hours = date.getHours();
  const originalMinutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const roundedMinutes = Math.round(originalMinutes / 15) * 15;
  const minutes = roundedMinutes % 60;
  if (roundedMinutes === 60) {
    hours = (hours % 12) + 1;
    if (hours === 12) {
      ampm = ampm === 'AM' ? 'PM' : 'AM';
    }
  }

  const formattedMinutes = minutes.toString().padStart(2, '0');
  const minInt = parseInt(formattedMinutes)
  return { hours, minInt, ampm };
};
 toggleAccordion = (id) => {
    this.setState((prevState) => ({
      open: prevState.open === id ? "" : id
    }));
  };
  render() {
    const {activities, sellershowingdetail, buyershowingdetail, openhouseshowingdetail, inviteDetail, userdetail} = this.props;
    const { totalContact, totalClient, totalLead, projecttopfive, deals, projectCounts, projectMonthNames, activity, open } = this.state;
     const initialStartTime = (activity.activityType === 1 ) ? this.convertISOTo12Hour( activity.startTime ) : '';
    const initialEndTime = (activity.activityType === 1 ) ? this.convertISOTo12Hour( activity.endTime ) : '';
    //
    const reports = [
      { title: "Total Leads", iconClass: "mdi mdi-account-group", description: totalLead, goto: '/lead/dashboard', viewTxt: "Manage your leads" },
      {
        title: "Total contacts",
        iconClass: "mdi mdi-account-details",
        description: totalContact,
        goto: '/contacts',
        viewTxt: "Manage your contacts"
      },
      {
        title: "Total Clients",
        iconClass: "mdi mdi-account-heart",
        description: totalClient,
        goto: '/clients',
        viewTxt: "Manage your clients"
      }
    ]
    const barchartdata = {
      series: [
        {

          data: projectCounts,
        }
      ],
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },

        grid: {
          borderColor: "#5A7CDE",
        },
        colors: ["#195772"],
        xaxis: {
          categories: projectMonthNames,
        },
      },
    };

     const clientnotificationsData = this.state.clientnotificationsData || [];
        const today = moment().startOf('day');
       const yesterday = moment().subtract(1, 'day').startOf('day');
        const sevenDaysAgo = moment().subtract(7, 'days').startOf('day');
    
    const filteredNotifications = clientnotificationsData.filter(notification => {
      const notifDate = moment(notification.notificationDate);
    
      if (this.state.activeTab === '1') {
        return notifDate.isSame(today, 'day');
      } else if (this.state.activeTab === '2') {
        return notifDate.isSame(yesterday, 'day');
      } else if (this.state.activeTab === '3') {
        return notifDate.isBetween(sevenDaysAgo, today.clone().endOf('day'), 'day', '[]');
      }
    
      return true;
    });


   
    return (

      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Lead Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid>
             <Breadcrumbs
              title={this.props.t("Lead")}
              breadcrumbItem={this.props.t("Dashboard")}
            />
            <Row>
              <Col lg="4">
                <WelcomeComp userdetail={userdetail} />
              </Col>
              <Col lg="8">
              <Row>
            {reports.map((report, key) => (
            <Col md="4" key={"_col_" + key}>
                <Link to={report.goto}><Card className="mini-stats-wid">
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className="mb-0">{report.description}</h4>
                              
                            </div>
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                              <span className="avatar-title">
                                <i
                                  className={
                                    "" + report.iconClass + " font-size-24"
                                  }
                                />
                              </span>
                            </div>
                            
                          </div>
                          
                        </CardBody>
                        <div className="clearfix"></div>
                            <h6 className="float-none link-bg"><Link to={report.goto}>{report.viewTxt}</Link></h6>
                      </Card></Link>
                
              </Col>
            ))}
            </Row>
              </Col>
            </Row>
        
                        <Row>
                           
                             <Col xs="12" sm="6" md="4" className="d-flex">
                                         <Card className="border-full w-100">
                                           <CardBody className="d-flex flex-column">
                               <div className="mb-4 card-title">Activity for today</div>
                               <div className="clearfix"></div>
                                
                                   <div>
                                    {/* Desktop Table */}
                                    <div className="table-responsive d-none d-md-block" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                      <table className="table table-striped mb-0">
                                        <thead className="bg-white sticky-top">
                                          <tr>
                                            <th className="align-middle">Type</th>
                                            <th className="align-middle">Name</th>
                                            <th className="align-middle">Phone</th>
                                            <th className="align-middle">Due Date</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                     {activities && activities.length > 0 ? (
                            activities.map((activity, prokey) => (
                              <tr key={prokey}>
                                <td>{activity.title}</td>
                               
                                 <td>
                                    {activity.activityLeadId > 0 ? (
                                      <Link to={`/lead/lead-detail/${activity.activityLeadId}/${activity.activityLeadGuid}`}>
                                        {activity.contactName}
                                      </Link>
                                    ) : activity.activityContactId > 0 ? (
                                      <Link to={`/contact/contact-detail/${activity.activityContactId}/${activity.activityContactGuid}`}>
                                        {activity.contactName}
                                      </Link>
                                    ) : activity.activityClientId > 0 ? (
                                      <Link to={`/clients/dashbord/${activity.activityClientId}/${activity.activityClientGuid}`}>
                                        {activity.contactName}
                                      </Link>
                                    ) : (
                                      activity.contactName
                                    )}
                                  </td>
                                <td>{activity.contactPhone}</td>
                                <td>
                                  {activity.activityStartDate ? (
                                    <Moment format="D MMM YY">{activity.activityStartDate}</Moment>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No data found
                              </td>
                            </tr>
                          )}
                                        </tbody>
                                      </table>
                                    </div>

                                    {/* Mobile Accordion */}
                                   <div className="d-block d-md-none">
  <Accordion open={open} toggle={this.toggleAccordion}>
    {activities && activities.length > 0 ? (
      activities.map((activity, prokey) => (
        <AccordionItem key={prokey}>
          <AccordionHeader targetId={`${prokey}`}>
            {activity.title} - {activity.contactName || "-"}
          </AccordionHeader>
          <AccordionBody accordionId={`${prokey}`}>
            <p>
              <strong>Phone:</strong> {activity.contactPhone || "-"}
            </p>
            <p>
              <strong>Due Date:</strong>{" "}
              {activity.activityStartDate ? (
                <Moment format="D MMM YY">{activity.activityStartDate}</Moment>
              ) : (
                "-"
              )}
            </p>
          </AccordionBody>
        </AccordionItem>
      ))
    ) : (
      <div className="text-center p-3">No data found</div>
    )}
  </Accordion>
</div>
                                  </div>

                                </CardBody>
                             </Card>
                          </Col>
                         <Col xs="12" sm="6" md="4" className="d-flex">
      <Card className="border-full w-100">
              <CardBody className="d-flex flex-column">
             <div className="card-title mb-4">Deals in  Progress</div>
                   
  <div>
  {/* Desktop Table */}
  <div className="table-responsive d-none d-md-block" style={{ maxHeight: '250px', overflowY: 'auto' }}>
    <table className="table table-striped mb-0">
      <thead className="bg-white sticky-top">
        <tr>
          <th>Start Date</th>
          <th>Client Name</th>
          <th>Type</th>
          <th>Amount</th>
        </tr>
      </thead>
     <tbody>
  {deals && deals.filter((deal) => deal.clientEngagementStatus === 1).length > 0 ? (
    deals
      .filter((deal) => deal.clientEngagementStatus === 1)
      .map((deal, index) => (
        <tr key={index}>
          <td>
            {deal.lastAgreementDate ? (
              <Moment format="DD MMM, YYYY">{deal.lastAgreementDate}</Moment>
            ) : (
              "-"
            )}
          </td>
          <td>{deal.contactName || "-"}</td>
          <td>
            {deal.isBuyer
              ? `Buyer${deal.buyerType ? ` - ${this.getBuyerType(deal.buyerType)}` : ""}`
              : deal.isSeller
              ? `Seller${deal.sellerType ? ` - ${this.getSellerType(deal.sellerType)}` : ""}`
              : deal.isInvestor
              ? "Investor"
              : "N/A"}
          </td>
          <td>${deal?.transactionAmount?.toFixed(2) || "0.00"}</td>
        </tr>
      ))
  ) : (
    <tr>
      <td colSpan="4" className="text-center">
        No data found
      </td>
    </tr>
  )}
</tbody>

    </table>
  </div>

  {/* Mobile Accordion */}
 

 <div className="d-block d-md-none">
  <Accordion open={this.state.open} toggle={this.toggleAccordion}>
    {deals && deals.filter((deal) => deal.clientEngagementStatus === 1).length > 0 ? (
      deals
        .filter((deal) => deal.clientEngagementStatus === 1)
        .map((deal, index) => (
          <AccordionItem key={index}>
            <AccordionHeader targetId={`deal-${index}`}>
              {deal.contactName} - ${deal?.transactionAmount?.toFixed(2) || "0.00"}
            </AccordionHeader>
            <AccordionBody accordionId={`deal-${index}`}>
              <p>
                <strong>Start Date:</strong>{" "}
                {deal.startDate ? (
                  <Moment format="DD MMM, YYYY">{deal.startDate}</Moment>
                ) : (
                  "-"
                )}
              </p>
              <p>
                <strong>Type:</strong>{" "}
                {deal.isBuyer
                  ? `Buyer${deal.buyerType ? ` - ${this.getBuyerType(deal.buyerType)}` : ""}`
                  : deal.isSeller
                  ? `Seller${deal.sellerType ? ` - ${this.getSellerType(deal.sellerType)}` : ""}`
                  : deal.isInvestor
                  ? "Investor"
                  : "N/A"}
              </p>
            </AccordionBody>
          </AccordionItem>
        ))
    ) : (
      <div className="text-center p-3">No data found</div>
    )}
  </Accordion>
</div>
</div>



</CardBody>
</Card>
              </Col>
                        {/* <Col xs="12" sm="6" md="4" className="d-flex">
                                         <Card className="border-full w-100">
                                           <CardBody className="d-flex flex-column">
                                             <h5 className="card-title w-100"> Client Interaction
                                                 <span className="float-end">
                                                                      
                                                                             <Nav className="projectTab actTabs" variant="tabs">
                                                                             <NavItem>
                                                                               <NavLink
                                                                               style={{ cursor: "pointer" }}
                                                                               className={classnames({
                                                                                 active: this.state.activeTab === "1",
                                                                               })}
                                                                               onClick={() => {
                                                                                 this.toggle("1");
                                                                                
                                                                               }}
                                                                             >
                                                                               <span className="">
                                                                                 {this.props.t("Today")}
                                                                               </span>
                                                                             </NavLink>
                                                                             </NavItem>
                                                                             <NavItem>
                                                                                <NavLink
                                                                               style={{ cursor: "pointer" }}
                                                                               className={classnames({
                                                                                 active: this.state.activeTab === "2",
                                                                               })}
                                                                               onClick={() => {
                                                                                 this.toggle("2");
                                                                                
                                                                               }}
                                                                             >
                                                                               <span className="">
                                                                                 {this.props.t("Yesterday")}
                                                                               </span>
                                                                             </NavLink>
                                                                               
                                                                             </NavItem>
                                                                             <NavItem>
                                                                               <NavLink
                                                                               style={{ cursor: "pointer" }}
                                                                               className={classnames({
                                                                                 active: this.state.activeTab === "3",
                                                                               })}
                                                                               onClick={() => {
                                                                                 this.toggle("3");
                                                                                 
                                                                               }}
                                                                             >
                                                                               <span className="">
                                                                                 {this.props.t("Past 7 Days")}
                                                                               </span>
                                                                             </NavLink>
                                                                              
                                                                             </NavItem>
                                             
                                                                                   </Nav>
                                                                                 
                                                                   </span>
                                             </h5>
                                            <div className="table-responsive" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                    <table className="table table-striped mb-0">
                                      <thead className="bg-white sticky-top">
                                                   <tr>
                                                     <th>Date</th>
                                                     <th>Note</th>
                                                    
                         
                                                   </tr>
                                                 </thead>
                                                 <tbody>
                                                {filteredNotifications.length > 0 ? (
                                                     filteredNotifications.map((cnotification, index) => (
                                                       <tr key={index}>
                                                         <td><Moment format="D MMM YY">{cnotification.notificationDate}</Moment></td>
                                                         <td>{cnotification.notificationText}</td>
                                                       </tr>
                                                     ))
                                                   ) : (
                                                     <tr>
                                                       <td colSpan="2" className="text-center">No interactions found</td>
                                                     </tr>
                                                   )}
                         
                         
                                                 </tbody>
                                               </table>
                                             </div>
                                           </CardBody>
                                         </Card>
                                       </Col> */}

                                    <Col xs="12" sm="6" md="4" className="d-flex">
  <Card className="border-full w-100">
    <CardBody className="d-flex flex-column">
      <h5 className="card-title w-100">
        Client Interaction
        <span className="float-end">
          {/* Desktop Tabs */}
          <div className="d-none d-md-block">
            <Nav className="projectTab actTabs" variant="tabs">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => this.toggle("1")}
                >
                  {this.props.t("Today")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab === "2",
                  })}
                  onClick={() => this.toggle("2")}
                >
                  {this.props.t("Yesterday")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab === "3",
                  })}
                  onClick={() => this.toggle("3")}
                >
                  {this.props.t("Past 7 Days")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          {/* Mobile Dropdown */}
          <div className="d-block d-md-none">
            <select
              className="form-select"
              value={this.state.activeTab}
              onChange={(e) => this.toggle(e.target.value)}
            >
              <option value="1">{this.props.t("Today")}</option>
              <option value="2">{this.props.t("Yesterday")}</option>
              <option value="3">{this.props.t("Past 7 Days")}</option>
            </select>
          </div>
        </span>
      </h5>

      <div
        className="table-responsive"
        style={{ maxHeight: "250px", overflowY: "auto" }}
      >
        <table className="table table-striped mb-0">
          <thead className="bg-white sticky-top">
            <tr>
              <th>Date</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            {filteredNotifications.length > 0 ? (
              filteredNotifications.map((cnotification, index) => (
                <tr key={index}>
                  <td>
                    <Moment format="D MMM YY">
                      {cnotification.notificationDate}
                    </Moment>
                  </td>
                  <td>{cnotification.notificationText}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="text-center">
                   No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </CardBody>
  </Card>
</Col>

          
                            
                        </Row>
            <Row >
             
             {/* <Col lg={6} className="d-flex">
                 <Card className="border-full w-100">
                <CardBody className="d-flex flex-column">
                    <div className="card-title mb-4 float-start card-bottom-border">Top 5 Projects</div>
                    <Table
                      id=""
                      className="table table-striped table-bordered border-left-off"
                    >
                      <thead>
                        <tr>
                          <th>Project</th>
                          <th>City</th>
                          <th># Clients</th>
                          <th># Leads</th>
                        </tr>
                      </thead>
                      <tbody>
                        {projecttopfive.map((project, index) => ( 
                          <tr key={index}>
                          <td>{project.projectName}
                            <br />
                            {project.builderName}
                          </td>
                          <td>{project.city}</td>
                          <td> {project.noOfClient} </td>
                          <td>{project.noOfLead}</td>
                        </tr>
                        ))}
                       

                      </tbody>
                    </Table>
                 </CardBody>
                 </Card>
              </Col> */}
              <Col lg={6} className="d-flex">
  <Card className="border-full w-100">
    <CardBody className="d-flex flex-column">
      <div className="card-title mb-4 float-start card-bottom-border">
        Top 5 Projects
      </div>

      {/* ✅ Table for desktop */}
      <div className="d-none d-md-block">
        <Table className="table table-striped table-bordered border-left-off">
          <thead>
            <tr>
              <th>Project</th>
              <th>City</th>
              <th># Clients</th>
              <th># Leads</th>
            </tr>
          </thead>
          <tbody>
            {projecttopfive && projecttopfive.length > 0 ? (
              projecttopfive.map((project, index) => (
                <tr key={index}>
                  <td>
                    {project.projectName || "-"}
                    <br />
                    {project.builderName || "-"}
                  </td>
                  <td>{project.city || "-"}</td>
                  <td>{project.noOfClient ?? "0"}</td>
                  <td>{project.noOfLead ?? "0"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* ✅ Accordion for mobile */}
      <div className="d-block d-md-none">
         <Accordion open={open} toggle={this.toggleAccordion}>
                                      {projecttopfive.map((project, prokey) => (
                                          <AccordionItem key={prokey}>
                                            <AccordionHeader targetId={`project-${prokey}`}>
                                               {project.projectName} - {project.city}
                                            </AccordionHeader>
                                            <AccordionBody accordionId={`project-${prokey}`}>
                                              <p>
                                                <strong>Builder:</strong> {project.builderName}
                                              </p>
                                              <p>
                                                <strong># Clients:</strong> {project.noOfClient}
                                              </p>
                                              <p>
                                                <strong># Leads:</strong> {project.noOfLead}
                                              </p>
                                            </AccordionBody>
                                          </AccordionItem>
                                        ))}
                                      </Accordion>
      </div>
    </CardBody>
  </Card>
</Col>

              <Col lg="6" className="d-flex">
                <Card className="border-full w-100">
                                           <CardBody className="d-flex flex-column">
              { barchartdata ?  <RSBarChart title="Projects launches" filter={false} height="370" series={barchartdata.series} options={barchartdata.options} /> :" " }
              </CardBody>
              </Card>
              </Col>
              
            </Row>
           
           
          </Container>
        </div>

        <Offcanvas
                  isOpen={this.state.isAddNew}
                  direction="end"
                  toggle={this.toggleAddNew}
                >
                  <OffcanvasHeader toggle={this.toggleAddNew}>
                    New Activity
                  </OffcanvasHeader>
                  <OffcanvasBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        agentId: parseInt(localStorage.getItem('userId')),
                        title: '',
                        contactName: '',
                        contactPhone: '',
                        contactEmail: '',
                        activityStartDate:'',
                        startTime:'',
                        endTime:'',
                        activityType: '3',
                        activityRefId:0,
                        activityStatus: 1,
                        activityDescription:'',
                        activityLocationType:'3',
                        activityLocation:'',
                        activityLatitude:'',
                        activityLongitude:'',
                        isActive:true
                      }}
                      validationSchema={Yup.object().shape({
                        activityType: Yup.string().required("This is Required"),
                        title: Yup.string().required("This is Required"),
                        contactName: Yup.string().required("This is Required"),
                        activityStartDate: Yup.string().required("This is Required")
                      })}
        
                      onSubmit={this.handleSubmit}
                     
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="builderName">
                                  {this.props.t("Type Of Activity")}
                                </Label>
                                <div className="clearfix"></div>
                                <div className="btn-group" role="group">
                                  <SafeField type="radio" className="btn-check" onChange={handleChange}       name="activityType" id="btnradio4" value="3" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>
        
                                  <SafeField type="radio" className="btn-check" onChange={handleChange}       name="activityType" id="btnradio5" value="1" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio5">Meeting</label>
        
                                  <SafeField type="radio" className="btn-check" onChange={handleChange} name="activityType" id="btnradio6"  value="2" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio6">To-do</label>
                                  <SafeField type="radio" className="btn-check" onChange={handleChange}       name="activityType" id="btnradio7"  value="4" autoComplete="off" />
                                  <label className="btn btn-outline-secondary"  htmlFor="btnradio7">Email</label>
                                  
                                </div>
                                <ErrorMessage
                                  name="activityType"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="title">
                                  {this.props.t("Subject")} <span className="requiredText">*</span>
                                </Label>
                                <SafeField
                                      name="title"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.title && touched.title
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="title"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="title"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactName">
                                  {this.props.t("Name")} <span className="requiredText">*</span>
                                </Label>
                                <SafeField
                                      name="contactName"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.contactName && touched.contactName
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="contactName"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="contactName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactEmail">
                                  {this.props.t("Email")}
                                </Label>
                                <SafeField
                                      name="contactEmail"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.contactEmail && touched.contactEmail
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="contactEmail"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="contactEmail"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
        
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactPhone">
                                  {this.props.t("Phone")}
                                </Label>
                                <SafeField
                                      name="contactPhone"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.contactPhone && touched.contactPhone
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="contactPhone"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="contactPhone"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                  
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="activityStartDate">
                                  {this.props.t("Date")} <span className="requiredText">*</span>
                                </Label>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.activityStartDate && touched.activityStartDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                  options={{
                                    altInput: false,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d"
                                  }}
                                />
                                 <ErrorMessage
                                  name="activityStartDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            { values.activityType === '1' && (
                            <>
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="startTime">
                                  {this.props.t("Start Time")}
                                </Label>
                                <Row>
                                <Col md="4">
                            <SafeField
                                name="startHrs"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleStartTime(setFieldValue, { ...values, startHrs: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.startHrs && touched.startHrs
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Hrs</option>
                                      {[...Array(12)].map((_, i) => (
                                        <option key={i + 1} value={i + 1} label={i + 1}>
                                          {i + 1}
                                        </option>
                                      ))}
                                </SafeField>
                                <ErrorMessage
                                  name="startHrs"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="startMin"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleStartTime(setFieldValue, { ...values, startMin: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.startMin && touched.startMin
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Mins</option>
                                 {[0, 15, 30, 45].map((value) => (
                                  <option key={value} value={value}>
                                      {value === 0 ? '00' : value}
                                  </option>
                                ))}
                                </SafeField>
                                <ErrorMessage
                                  name="startMin"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="startDif"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleStartTime(setFieldValue, { ...values, startDif: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.startDif && touched.startDif
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                <option value='AM'>AM</option>
                                <option value='PM'>PM</option>
                                </SafeField>
                                <ErrorMessage
                                  name="startDif"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                                </Row>
                              </FormGroup>
                            </Col>
        
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="endTime">
                                  {this.props.t("End Time")}
                                </Label>
                                <Row>
                                <Col md="4">
                            <SafeField
                                name="endHrs"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.endHrs && touched.endHrs
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Hrs</option>
                                      {[...Array(12)].map((_, i) => (
                                        <option key={i + 1} value={i + 1} label={i + 1}>
                                          {i + 1}
                                        </option>
                                      ))}
                                </SafeField>
                                <ErrorMessage
                                  name="endHrs"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="endMin"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.endMin && touched.endMin
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Mins</option>
                                 {[0, 15, 30, 45].map((value) => (
                                  <option key={value} value={value}>
                                      {value === 0 ? '00' : value}
                                  </option>
                                ))}
                                </SafeField>
                                <ErrorMessage
                                  name="endMin"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="endDif"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleEndTime(setFieldValue, { ...values, endDif: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.endDif && touched.endDif
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                <option value='AM'>AM</option>
                                <option value='PM'>PM</option>
                                </SafeField>
                                <ErrorMessage
                                  name="endDif"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                                </Row>
                              </FormGroup>
                            </Col>
                            </>
                            )}
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="activityDescription">
                                  {this.props.t("Notes")}
                                </Label>
                                <SafeField
                                  name="activityDescription"
                                  onChange={handleChange}                            
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.activityDescription && touched.activityDescription
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="activityDescription"
                                  
                                /> 
                              </FormGroup>
                            </Col>
                            { values.activityType === '1' && (
                            <>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="notes">
                                  {this.props.t("Location")}
                                </Label>
                                <div className="clearfix"></div>
                                <div className="btn-group" role="group">
        
                                  <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio9" value="3" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio9">In-person</label>
                                  <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio10" value="1" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio10">Online</label>
                                </div>
        
                              </FormGroup>
                            </Col>
        
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="addressLine1">
                                  {this.props.t("Location")}
                                </Label>
                                {values.activityLocationType === '3' ? (
                                <PlacesAutocomplete
                                  value={values.activityLocation}
                                  onChange={(value) => setFieldValue('activityLocation', value)}
                                  onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                >
                                  {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div>
                                      <input
                                        {...getInputProps({
                                          placeholder: 'Enter Address...',
                                          className: 'form-control',
        
                                        })}
                                      />
                                      <div className="">
                                        {loading ? <div>Loading...</div> : null}
        
                                        {suggestions.map((suggestion, i) => {
                                          const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                          const style = suggestion.active
                                            ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                            : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
        
                                          return (
                                            <div
                                              key={i}
                                              {...getSuggestionItemProps(suggestion, {
                                                style,
                                              })}
                                            >
                                              {suggestion.description}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
                                ) : (
                                  <SafeField
                                  name="activityLocation"
                                  onChange={handleChange}                            
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.activityLocation && touched.activityLocation
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="activityLocation"
                                  
                                /> 
                                )}
                              </FormGroup>
                            </Col>
                            </>
                            )}
        
        
                            {/* <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="notes">
                                  {this.props.t("Assigned to")}
                                </Label>
                                <SafeField
                                  name="activityLocation"
                                  onChange={handleChange}                            
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.activityLocation && touched.activityLocation
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="activityLocation"
                                  
                                /> 
                              </FormGroup>
                            </Col> */}
        
        
        
                          </Row>
        
                          <Row>
        
                            <div className="clearFix">
                              <SaveButton>Save</SaveButton>
                              </div>
                          </Row>
        
                        </Form>
                      )}
                    </Formik>
        
                  </OffcanvasBody>
                </Offcanvas>
        
                <Offcanvas
                                    isOpen={this.state.iseditOpen}
                                    direction="end"
                                    toggle={this.toggleEdit}
                                >
                                    <OffcanvasHeader toggle={this.toggleEdit}>
                                        Update
                                    </OffcanvasHeader>
                                    <OffcanvasBody>
                                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                                id: activity?.id,
                                activityId: activity.activityId,
                                agentId: parseInt(activity.agentId),
                                title: activity.title,
                                contactName: activity.contactName,
                                contactPhone: activity.contactPhone,
                                contactEmail: activity.contactEmail,
                                activityStartDate: activity.activityStartDate,
                                startTime: activity.startTime,
                                endTime: activity.endTime,
                                startHrs: (activity.activityType==1) ? initialStartTime.hours : '',
                                startMin: (activity.activityType==1) ?  initialStartTime.minInt: '',
                                startDif: (activity.activityType==1) ? initialStartTime.ampm : '',
                                endHrs:   (activity.activityType==1) ? initialEndTime.hours : '',
                                endMin:   (activity.activityType==1) ? initialEndTime.minInt: '',
                                endDif:   (activity.activityType==1) ? initialEndTime.ampm : '',
                                activityType: String(activity.activityType),
                                activityStatus: activity.activityStatus,
                                activityRefId: activity.activityRefId,
                                activityDescription: activity.activityDescription,
                                activityLocationType: String(activity.activityLocationType),
                                activityLocation: activity.activityLocation,
                                activityLatitude: activity.activityLatitude,
                                activityLongitude: activity.activityLongitude,
                                isActive: activity.isActive,
                                markAsDone: (activity.activityStatus==3) ? true : false,
                      }}
                      validationSchema={Yup.object().shape({
                        activityType: Yup.string().required("This is Required"),
                        title: Yup.string().required("This is Required"),
                        contactName: Yup.string().required("This is Required"),
                        activityStartDate: Yup.string().required("This is Required")
                      })}
        
                      onSubmit={values => {
        
                        if (isEdit) {
                            const updateData = {
                              id: values.id,
                              activityId: values.activityId,
                              agentId: parseInt(values.agentId),
                              title: values.title,
                              contactName: values.contactName,
                              contactPhone: values.contactPhone,
                              contactEmail: values.contactEmail,
                              activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),
                              startTime: moment(values.startTime).toISOString(),
                              endTime: moment(values.endTime).toISOString(),
                              activityType: parseInt(values.activityType),
                              activityStatus: values.markAsDone ? 3 : parseInt(values.activityStatus),
                              activityRefId: parseInt(values.activityRefId),
                              activityDescription: values.activityDescription,
                              activityLocationType: parseInt(values.activityLocationType),
                              activityLocation: values.activityLocation,
                              activityLatitude: values.activityLatitude ? values.activityLatitude : null,
                              activityLongitude: values.activityLongitude ? values.activityLongitude : null,
                              isActive: values.isActive
                            };
                            onUpdateMainActivity(updateData);
                        } else {
        
                        }
                        this.editToggle();
                      }}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="builderName">
                                  {this.props.t("Type Of Activity")}
                                </Label>
                                <div className="clearfix"></div>
                                <div className="btn-group" role="group">
                                  <SafeField type="radio" className="btn-check" onChange={handleChange}       name="activityType" id="btnradio4" value="3" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>
        
                                  <SafeField type="radio" className="btn-check" onChange={handleChange}       name="activityType" id="btnradio5" value="1" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio5">Meeting</label>
        
                                  <SafeField type="radio" className="btn-check" onChange={handleChange} name="activityType" id="btnradio6"  value="2" autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio6">To-do</label>
                                  <SafeField type="radio" className="btn-check" onChange={handleChange}       name="activityType" id="btnradio7"  value="4" autoComplete="off" />
                                  <label className="btn btn-outline-secondary"  htmlFor="btnradio7">Email</label>
                                  
                                </div>
                                <ErrorMessage
                                  name="activityType"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="title">
                                  {this.props.t("Subject")}
                                </Label>
                                <SafeField
                                      name="title"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.title && touched.title
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="title"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="title"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactName">
                                  {this.props.t("Name")}
                                </Label>
                                <SafeField
                                      name="contactName"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.contactName && touched.contactName
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="contactName"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="contactName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactEmail">
                                  {this.props.t("Email")}
                                </Label>
                                <SafeField
                                      name="contactEmail"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.contactEmail && touched.contactEmail
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="contactEmail"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="contactEmail"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
        
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactPhone">
                                  {this.props.t("Phone")}
                                </Label>
                                <SafeField
                                      name="contactPhone"
                                      onChange={handleChange}                            
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.contactPhone && touched.contactPhone
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="contactPhone"
                                      
                                    /> 
                                   <ErrorMessage
                                  name="contactPhone"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                  
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="activityStartDate">
                                  {this.props.t("Date")}
                                </Label>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.activityStartDate && touched.activityStartDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value={values.activityStartDate}
                                  onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                  options={{
                                    altInput: false,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d"
                                  }}
                                />
                                 <ErrorMessage
                                  name="activityStartDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            { values.activityType === "1" && (
                            <>       
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="startTime">
                                  {this.props.t("Start Time")}
                                </Label>
                                <Row>
                                <Col md="4">
                            <SafeField
                                name="startHrs"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleStartTime(setFieldValue, { ...values, startHrs: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.startHrs && touched.startHrs
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Hrs</option>
                                      {[...Array(12)].map((_, i) => (
                                        <option key={i + 1} value={i + 1} label={i + 1}>
                                          {i + 1}
                                        </option>
                                      ))}
                                </SafeField>
                                <ErrorMessage
                                  name="startHrs"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="startMin"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleStartTime(setFieldValue, { ...values, startMin: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.startMin && touched.startMin
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Mins</option>
                                 {[0, 15, 30, 45].map((value) => (
                                  <option key={value} value={value}>
                                      {value === 0 ? '00' : value}
                                  </option>
                                ))}
                                </SafeField>
                                <ErrorMessage
                                  name="startMin"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="startDif"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleStartTime(setFieldValue, { ...values, startDif: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.startDif && touched.startDif
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                <option value='AM'>AM</option>
                                <option value='PM'>PM</option>
                                </SafeField>
                                <ErrorMessage
                                  name="startDif"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                                </Row>
                              </FormGroup>
                            </Col>
        
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="endTime">
                                  {this.props.t("End Time")}
                                </Label>
                                <Row>
                                <Col md="4">
                            <SafeField
                                name="endHrs"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.endHrs && touched.endHrs
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Hrs</option>
                                      {[...Array(12)].map((_, i) => (
                                        <option key={i + 1} value={i + 1} label={i + 1}>
                                          {i + 1}
                                        </option>
                                      ))}
                                </SafeField>
                                <ErrorMessage
                                  name="endHrs"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="endMin"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.endMin && touched.endMin
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                 <option value="">Mins</option>
                                 {[0, 15, 30, 45].map((value) => (
                                  <option key={value} value={value}>
                                      {value === 0 ? '00' : value}
                                  </option>
                                ))}
                                </SafeField>
                                <ErrorMessage
                                  name="endMin"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                            <Col md="4">
                            <SafeField
                                name="endDif"
                                as="select"
                                
                                onChange={e => {
                                  handleChange(e);
                                  this.handleEndTime(setFieldValue, { ...values, endDif: e.target.value });
                                }}
                                className={
                                    "form-control" +
                                    (errors.endDif && touched.endDif
                                    ? " is-invalid"
                                    : "")
                                }
                                id="hrs"
                                >
                                <option value='AM'>AM</option>
                                <option value='PM'>PM</option>
                                </SafeField>
                                <ErrorMessage
                                  name="endDif"
                                  component="div"
                                  className="invalid-feedback"
                                />
                            </Col>
                                </Row>
                              </FormGroup>
                            </Col>
                                </>
                            )}
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="activityDescription">
                                  {this.props.t("Notes")}
                                </Label>
                                <SafeField
                                  name="activityDescription"
                                  onChange={handleChange}                            
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.activityDescription && touched.activityDescription
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="activityDescription"
                                  
                                /> 
                              </FormGroup>
                            </Col>
                            { values.activityType === "1" && (
                            <>       
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="notes">
                                  {this.props.t("Location")}
                                </Label>
                                <div className="clearfix"></div>
                                <div className="btn-group" role="group">
        
                                  <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio9" value="3"
                                     onChange={e => {
                                      handleChange(e);
                                      setFieldValue('activityLocation', '');
                                      setFieldValue('activityLatitude', '');
                                      setFieldValue('activityLongitude', '');
                                    }}
                                  
                                  autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio9">In-person</label>
                                  <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio10" value="1"
                                  onChange={e => {
                                    handleChange(e);
                                    setFieldValue('activityLocation', '');
                                    setFieldValue('activityLatitude', '');
                                    setFieldValue('activityLongitude', '');
                                  }}
                                  autoComplete="off" />
                                  <label className="btn btn-outline-secondary" htmlFor="btnradio10">Online</label>
                                </div>
        
                              </FormGroup>
                            </Col>
        
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="addressLine1">
                                  {this.props.t("Location")}
                                </Label>
                                {values.activityLocationType === "3" ? (
                                <PlacesAutocomplete
                                  value={values.activityLocation}
                                  onChange={(value) => setFieldValue('activityLocation', value)}
                                  onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                >
                                  {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div>
                                      <input
                                        {...getInputProps({
                                          placeholder: 'Enter Address...',
                                          className: 'form-control',
        
                                        })}
                                      />
                                      <div className="">
                                        {loading ? <div>Loading...</div> : null}
        
                                        {suggestions.map((suggestion, i) => {
                                          const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                          const style = suggestion.active
                                            ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                            : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
        
                                          return (
                                            <div
                                              key={i}
                                              {...getSuggestionItemProps(suggestion, {
                                                style,
                                              })}
                                            >
                                              {suggestion.description}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
                                ) : (
                                  <SafeField
                                  name="activityLocation"
                                  onChange={handleChange}                            
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.activityLocation && touched.activityLocation
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="activityLocation"
                                  
                                /> 
                                )}
                              </FormGroup>
                            </Col>
                            </>
                            )}
                          </Row>
                          <Col md="12">
                              <FormGroup className="mb-3">
                               
                                <SafeField
                                      name="markAsDone"
                                      checked={values.markAsDone}
                                      onChange={() => this.handleCheckboxChange(values, setFieldValue)}
                                      type="checkbox"
                                      id="markAsDone"
                                      
                                    /> {" "}
                                     <Label htmlFor="markAsDone">
                                  {this.props.t("Mark as done")}
                                </Label>
                                   
                              </FormGroup>
                            </Col>
                          <Row>
        
                            <div className="clearFix">
                              <button type="submit" className="btn btn-primary w-md  mt20" name="addActivity" id="addActivity"> {this.props.t("Update")}</button>{" "}
                              <button type="button" className="btn btn-del-cancle w-md  mt20" onClick={this.toggleEdit}> {this.props.t("Cancel")}</button>{" "}
                              <button type="button" className="btn btn-del-danger w-md  mt20" onClick={() => this.onClickDelete(activity)}> {this.props.t("Delete")}</button></div>
                          </Row>
        
                        </Form>
                      )}
                    </Formik>
                                    </OffcanvasBody>
                </Offcanvas>
        
                <Offcanvas
                  isOpen={this.state.isSellerShowing}
                  direction="end"
                  toggle={this.toggleSellerShowing}
              >
                  <OffcanvasHeader toggle={this.toggleSellerShowing}>
                      Seller Showing
                  </OffcanvasHeader>
                  <OffcanvasBody>
                  <div className="table-responsive">
                  { sellershowingdetail ? (
                  <Table className="table table-sm m-0">
                                
                                <tbody>
                                  <tr>
                                    <th scope="row">Listing</th>
                                    <td>{sellershowingdetail.clientListing.mlsId}</td>
        
                                  </tr>
                                  <tr>
                                  <th scope="row">Openhouse Date</th>
                                    <td>{sellershowingdetail.showingDate ? <Moment format="D MMM YY">{sellershowingdetail.showingDate}</Moment> : '' }</td>      
                                  </tr>
                                  <tr>
                                    <th scope="row">Start Time</th>
                                    <td><Moment format="hh:mm A">{sellershowingdetail.startTime}</Moment></td>
                                   
                                  </tr>
                                  <tr>
                                  <th scope="row">End Time</th>
                                  <td><Moment format="hh:mm A">{sellershowingdetail.endTime}</Moment></td>
                                  
                                  </tr>
        
                                  <tr>
                                  <th scope="row">Agent Name</th>
                                  <td>{sellershowingdetail.agentName}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">Agent Organization</th>
                                  <td>{sellershowingdetail.agentOrganization}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">Agent Contact</th>
                                  <td>{sellershowingdetail.agentContact}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">Agent Email</th>
                                  <td>{sellershowingdetail.agentEmail}</td>
                                  </tr>
                                                       
                                </tbody>
                              </Table>
                  ): null}
                            </div>    
                  </OffcanvasBody>
                  </Offcanvas>
        
                  <Offcanvas
                  isOpen={this.state.isBuyerShowing}
                  direction="end"
                  toggle={this.toggleBuyerShowing}
              >
                  <OffcanvasHeader toggle={this.toggleBuyerShowing}>
                      Buyer Showing
                  </OffcanvasHeader>
                  <OffcanvasBody>
                  <div className="table-responsive">
                  { buyershowingdetail ? (
                  <Table className="table table-sm m-0">
                                
                                <tbody>
                                  <tr>
                                    <th scope="row">Listing</th>
                                    <td>{buyershowingdetail.mlsId}</td>
        
                                  </tr>
                                  <tr>
                                  <th scope="row">Listing Date</th>
                                    <td>{buyershowingdetail.listingDate ? <Moment format="D MMM YY">{buyershowingdetail.listingDate}</Moment> : '' }</td>      
                                  </tr>
                                  <tr>
                                    <th scope="row">Listing Status</th>
                                    <td>{this.getStatus(buyershowingdetail.listingStatusId)}</td>
                                   
                                  </tr>
                                  <tr>
                                  <th scope="row">Listed Price</th>
                                  <td>${buyershowingdetail.listedPrice}</td>
                                  
                                  </tr>
        
                                  <tr>
                                  <th scope="row">Listing Type</th>
                                  <td>{buyershowingdetail.listingType ? localization["ListingType_" + buyershowingdetail.listingType] : ''}</td>
                                  
                                  </tr>
        
                                  <tr>
                                  <th scope="row">Bedroom</th>
                                  <td>{buyershowingdetail.listingBedroom}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">Bathroom</th>
                                  <td>{buyershowingdetail.listingBathroom}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">Parking</th>
                                  <td>{buyershowingdetail.listingParking}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">Address</th>
                                  <td>{buyershowingdetail.listingAddress}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">City</th>
                                  <td>{buyershowingdetail.listingCity}</td>
                                  </tr>
                                  <tr>
                                  <th scope="row">Notes</th>
                                  <td>{buyershowingdetail.notes}</td>
                                  </tr>
                                                       
                                </tbody>
                              </Table>
                  ): null}
                            </div>    
                  </OffcanvasBody>
                  </Offcanvas>
        
                  <Offcanvas
                  isOpen={this.state.isOpenhouseShowing}
                  direction="end"
                  toggle={this.toggleOpenhouseShowing}
              >
                  <OffcanvasHeader toggle={this.toggleOpenhouseShowing}>
                      Open House Showing
                  </OffcanvasHeader>
                  <OffcanvasBody>
                  <div className="table-responsive">
                  { openhouseshowingdetail ? (
                  <Table className="table table-sm m-0">
                                
                                <tbody>
                                  <tr>
                                    <th scope="row">Listing</th>
                                    <td>{openhouseshowingdetail.clientListing.mlsId}</td>
        
                                  </tr>
                                  <tr>
                                  <th scope="row">Openhouse Date</th>
                                    <td>{openhouseshowingdetail.openhouseDate ? <Moment format="D MMM YY">{openhouseshowingdetail.openhouseDate}</Moment> : '' }</td>      
                                  </tr>
                                  <tr>
                                    <th scope="row">Start Time</th>
                                    <td><Moment format="hh:mm A">{openhouseshowingdetail.startTime}</Moment></td>
                                   
                                  </tr>
                                  <tr>
                                  <th scope="row">End Time</th>
                                  <td><Moment format="hh:mm A">{openhouseshowingdetail.endTime}</Moment></td>
                                  
                                  </tr>
                                                       
                                </tbody>
                              </Table>
                  ): null}
                    
                  </div>    
                  </OffcanvasBody>
                  </Offcanvas>
        
                  <Offcanvas
                  isOpen={this.state.isEventShowing}
                  direction="end"
                  toggle={this.toggleEventShowing}
              >
                  <OffcanvasHeader toggle={this.toggleEventShowing}>
                      Event Invites
                  </OffcanvasHeader>
                  <OffcanvasBody>
                  <div className="table-responsive">
                  { inviteDetail ? (
                  <Table className="table table-sm m-0">
                                
                                <tbody>
                                  <tr>
                                    <th scope="row">Project Name</th>
                                    <td>{inviteDetail.projectName}</td>
        
                                  </tr>
                                  <tr>
                                    <th scope="row">Event Name</th>
                                    <td>{inviteDetail.eventName}</td>
        
                                  </tr>
                                  <tr>
                                  <th scope="row">Event Date</th>
                                    <td>{inviteDetail.eventDate ? <Moment format="D MMM YY">{inviteDetail.eventDate}</Moment> : '' }</td>      
                                  </tr>
                                  <tr>
                                    <th scope="row">Start Time</th>
                                    <td><Moment format="hh:mm A" parse="HH:mm">{inviteDetail.eventStartTime}</Moment></td>
                                   
                                  </tr>
                                  <tr>
                                  <th scope="row">End Time</th>
                                  <td><Moment format="hh:mm A" parse="HH:mm">{inviteDetail.eventEndTime}</Moment></td>
                                  
                                  </tr>
        
                                  <tr>
                                  <th scope="row">Location</th>
                                  <td>{inviteDetail.address ? inviteDetail.address : inviteDetail.location }</td>
                                  
                                  </tr>
        
                                 
                                                       
                                </tbody>
                              </Table>
                  ): null}
                            </div>    
                  </OffcanvasBody>
                  </Offcanvas>
      </React.Fragment>
    )
  }
}
DashboardNew.propTypes = {
  t: PropTypes.any,
  postActivityFilter:PropTypes.func,
  activities:PropTypes.array,
    onGetOpenhouseShowingDetail:PropTypes.func,
    onGetSellerShowingDetail:PropTypes.func,
    onGetBuyerShowingDetail:PropTypes.func,
    onGetProjectInviteDetail:PropTypes.func,
    sellershowingdetail:PropTypes.object,
    buyershowingdetail:PropTypes.object,
    openhouseshowingdetail:PropTypes.object,
    inviteDetail:PropTypes.object,
    userdetail:PropTypes.object
}
const mapStateToProps = ({ Activity, Project }) => (
  {
    loading: Activity.loading,
    activities:Activity.activities,
     sellershowingdetail:Activity.sellershowingdetail,
    openhouseshowingdetail:Activity.openhouseshowingdetail,
    buyershowingdetail:Activity.buyershowingdetail,
     inviteDetail:Project.inviteDetail
    
   
  })
const mapDispatchToProps = dispatch => ({
  postActivityFilter : (data) => dispatch(postActivityFilter(data)),
    onGetSellerShowingDetail:(id) => dispatch(getSellerShowingDetail(id)),
    onGetOpenhouseShowingDetail:(id) => dispatch(getOpenhouseShowingDetail(id)),
    onGetBuyerShowingDetail:(id) => dispatch(getBuyerShowingDetail(id)),
    onGetProjectInviteDetail:(id) => dispatch(getProjectInviteDetail(id))
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DashboardNew))
